import $ from 'jquery';

/*
 * Generic click-to-sort for plain, non-paginated HTML tables (no backend
 * involved - every row is already rendered, this just reorders the <tr>
 * elements client-side). Opt in by adding:
 *   - class "sortable-table" to the <table>
 *   - data-sort-type="text|number" to each sortable <thead th>
 *   - a matching data-sort-value="<comparable value>" on each row's <td>
 *     at the same column index (e.g. an ISO date string for date columns,
 *     since those sort correctly as plain text)
 */
$(document).ready(function () {
    $('.sortable-table').each(function () {
        const $table = $(this);
        const $headers = $table.find('thead th[data-sort-type]');

        $headers.each(function (index) {
            const $th = $(this);
            $th.css('cursor', 'pointer')
                .append(' <i class="bi bi-arrow-down-up text-muted sort-icon"></i>');

            $th.on('click', function () {
                const type = $th.data('sort-type');
                const dir = $th.data('sort-dir') === 'asc' ? 'desc' : 'asc';

                $headers.not($th).removeData('sort-dir')
                    .find('.sort-icon').attr('class', 'bi bi-arrow-down-up text-muted sort-icon');

                $th.data('sort-dir', dir);
                $th.find('.sort-icon').attr('class', `bi bi-sort-${dir === 'asc' ? 'up' : 'down'} sort-icon`);

                const $tbody = $table.find('tbody');
                const rows = $tbody.find('tr').toArray();

                rows.sort((rowA, rowB) => {
                    const a = $(rowA).find('td').eq(index).attr('data-sort-value') || '';
                    const b = $(rowB).find('td').eq(index).attr('data-sort-value') || '';

                    const cmp = type === 'number'
                        ? (parseFloat(a) || 0) - (parseFloat(b) || 0)
                        : a.localeCompare(b);

                    return dir === 'asc' ? cmp : -cmp;
                });

                $tbody.append(rows);
            });
        });
    });
});
